module.exports = __webpack_public_path__ + "media/applicants/instacart-carrot-logo-1948cb77.png";